type Id = string | number;

/**
 * Audit-domain query keys (Server-state rebuild, P4-tail). Flat, independent roots (no
 * cascade between them), preserving today's exact values. Covers the audit entity, its
 * status/report/archive job polls, roles, and team membership.
 */
export const auditKeys = {
  list: () => ['audits'] as const,
  detail: (auditId?: string) => ['audit', auditId] as const,

  status: (auditId?: string) => ['audit-status', auditId] as const,
  reportStatus: (auditId?: string, jobId?: Id | null) =>
    ['audit-report-status', auditId, jobId ? String(jobId) : 'actionable'] as const,
  archiveStatus: (auditId?: string, jobId?: Id | null) =>
    ['audit-archive-status', auditId, jobId ? String(jobId) : 'actionable'] as const,

  roles: (auditId?: string) => ['audit-roles', auditId] as const,
  role: (auditId?: string, roleId?: string) => ['audit-role', auditId, roleId] as const,
  myRole: (auditId?: string) => ['userRole', auditId] as const,

  myTeam: (auditId?: string) => ['my-audit-team', auditId] as const,
  teamMembers: (auditId?: string) => ['audit-team-members', auditId] as const,
  participants: (auditId?: string) => ['audit-participants', auditId] as const,
  auditorFirmMembers: (auditId?: string) => ['audit-auditor-firm-members', auditId] as const,
} as const;
